import { Directive } from '@angular/core';

/** Used as template for no results */

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[noResultsTmpl]'
})
export class NoResultsTmplDirective {
}
